import React, { useState, useEffect } from "react"
import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap"
import API from "../../api/axios"
import { FaRegEyeSlash } from "react-icons/fa6"
import { useNavigate } from "react-router-dom"
import DoctorTimetable from "./DoctorAvailabilityForm"
import { setBreadcrumbItems } from "../../store/actions"
import { connect } from "react-redux"
const AvailabilityTable = props => {
  const navigate = useNavigate()
  const [availabilityData, setAvailabilityData] = useState([])

  useEffect(() => {
    fetchAvailability()
  }, [])

  const handleEditClick = availability => {
    console.log("availability object: ", availability)
    console.log("availability details for id: ", availability?.id)
    navigate(`/availability-profile/${availability?.id}`, {
      state: { availabilityData: availability },
    })
  }

  const fetchAvailability = async () => {
    try {
      const authToken = localStorage.getItem("authToken")
      const response = await API.get(
        "/doctorAvailibility",
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-type": "application/json",
          },
        },
      )
      // console.log("Latest availability data:", response?.data?.data)
      props.setBreadcrumbItems("Time Table", breadcrumbItems)
      setAvailabilityData(response?.data?.data)
    } catch (error) {
      console.error("Error fetching availability:", error.message)
    }
  }

  const breadcrumbItems = [
    { title: "Dashboard", link: "/dashboard" },
    { title: "Time Table", link: "#" },
  ]

  const formatTime = time => {
    if (!time) return "--"

    const [hours, minutes] = time.split(":").map(Number)

    let formattedHours = hours
    const period = formattedHours >= 12 ? "PM" : "AM"
    formattedHours = formattedHours % 12 || 12
    const formattedMinutes = minutes.toString().padStart(2, "0")

    return `${formattedHours}:${formattedMinutes} ${period}`
  }

  const formatDaySlot = dayData => {
    if (
      !dayData ||
      !dayData.available ||
      !dayData.starttime ||
      !dayData.endtime
    ) {
      return "Not sitting"
    }
    return `${formatTime(dayData.starttime)} - ${formatTime(dayData.endtime)}`
  }

  const tableDataConfig = {
    columns: [
      { label: "Doctor Name", field: "doctorName", sort: "asc", width: 200 },
      { label: "Speciality", field: "speciality", sort: "asc", width: 150 },
      { label: "Monday", field: "monday", sort: "asc", width: 150 },
      { label: "Tuesday", field: "tuesday", sort: "asc", width: 150 },
      { label: "Wednesday", field: "wednesday", sort: "asc", width: 150 },
      { label: "Thursday", field: "thursday", sort: "asc", width: 150 },
      { label: "Friday", field: "friday", sort: "asc", width: 150 },
      { label: "Saturday", field: "saturday", sort: "asc", width: 150 },
      // { label: "Sunday", field: "sunday", sort: "asc", width: 150 },
      { label: "Action", field: "action", sort: "disabled", width: 100 },
    ],
    rows: availabilityData.map(availability => {
      // console.log("availability data", availability.data)

      const getDay = dayName =>
        availability.availability.find(d => d.day.toLowerCase() === dayName)

      return {
        doctorName: availability.name || "N/A",
        speciality: availability.services?.join(", ") || "N/A",
        monday: formatDaySlot(getDay("monday")),
        tuesday: formatDaySlot(getDay("tuesday")),
        wednesday: formatDaySlot(getDay("wednesday")),
        thursday: formatDaySlot(getDay("thursday")),
        friday: formatDaySlot(getDay("friday")),
        saturday: formatDaySlot(getDay("saturday")),
        action: (
          <button
            className="btn btn-success"
            onClick={() => handleEditClick(availability)}
          >
            <FaRegEyeSlash size={20} />
          </button>
        ),
      }
    }),
  }

  return (
    <div>
      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              <DoctorTimetable refresh={fetchAvailability} />
              <CardTitle className="h4">Doctor Time Table</CardTitle>
              <MDBDataTable
                responsive
                bordered
                striped
                data={tableDataConfig}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default connect(null, { setBreadcrumbItems })(AvailabilityTable)
